
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply component specific CSS */
.visually-hidden{clip-path:inset(50%);height:1px;overflow:hidden;position:absolute!important;width:1px}.main-wrapper{border:1px solid var(--black-600);border-radius:var(--br-min);-moz-column-gap:var(--gap-5lg);column-gap:var(--gap-5lg);display:grid;grid-template-columns:auto 1fr;padding:var(--spacing-12) var(--spacing-16)}.main-wrapper.mobile{grid-template-columns:1fr}.content{display:flex;flex-direction:row;flex-wrap:wrap;gap:var(--gap-base);justify-content:space-between;padding-top:var(--spacing-7)}tufts-button{--tufts-btn-gap:var(--gap-xs)}`;